
















import { BButton } from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import VueObserveVisibility from "vue-observe-visibility";

export default {
    components: {
        BButton,
    },
    directives: {
        VueObserveVisibility,
    },
    setup() {
        const scrollToBottomButtonVisible = ref(false);

        const handleShowScrollToBottomButton = (isVisible: boolean): void => {
            scrollToBottomButtonVisible.value = !isVisible;
        };

        return {
            scrollToBottomButtonVisible,
            handleShowScrollToBottomButton,
        };
    },
};
